import { z } from 'zod';
import { baseModelSchema } from '../../../model/baseModel';
import { IPalletBaseTypeFormValues } from './palletBaseTypeFormValues';

/**
 * Zod schema for validating pallet base type data.
 * Extends the base model schema with pallet base type-specific fields.
 * Represents a type of pallet base used for stacking and transporting goods.
 *
 * @property {string} code - Unique identifier code (max 5 characters)
 * @property {string} name - Name of the pallet base type (max 255 characters)
 * @property {number} defaultWeight - Default weight of the pallet base in kilograms (min 0)
 */
export const palletBaseTypeSchema = baseModelSchema.extend({
    code: z.string().nonempty('Code is required').max(5, 'Code can only be up to 5 characters long.').default(''),
    name: z.string().nonempty('Name is required').max(255, 'Name can only be up to 255 characters long.').default(''),
    defaultWeight: z.number().min(0, 'Default Weight must be 0 or greater').default(0),
});

// Infer TypeScript type
export type IPalletBaseType = z.infer<typeof palletBaseTypeSchema>;

/**
 * Creates a validated PalletBaseType object from form values.
 *
 * @param {IPalletBaseTypeFormValues} formValues - The form data to convert
 * @returns {IPalletBaseType} A validated pallet base type object
 * @throws {ZodError} If validation fails
 */
export function PalletBaseType(formValues : IPalletBaseTypeFormValues) : IPalletBaseType {
    return palletBaseTypeSchema.parse({
        ...formValues,
    });
}
